/**
 * @file 普通行
 */
import cls from 'classnames';
import { ArrowchevronRightIcon } from '@bfe/moly-icons';

import styles from './index.module.css';

interface Props {
  show?: boolean;
  label: string;
  value: string | React.ReactNode;
  tooltipText?: string;
  className?: string;
  labelClassName?: string;
  valueClassName?: string;
  showArrow?: boolean;
  onClickArrow?: () => void;
}

export const Row = (props: Props) => {
  const {
    label,
    value,
    className,
    showArrow,
    onClickArrow,
    labelClassName,
    valueClassName,
    show = true,
  } = props;
  return (
    show && (
      <div className={cls(styles.container, className)}>
        <div className={cls(styles.label, labelClassName)}>{label}</div>
        {showArrow && (
          <div className={cls(styles.value, valueClassName)}>
            {value}
            <ArrowchevronRightIcon
              className={styles.arrow}
              onClick={onClickArrow}
            />
          </div>
        )}
        {!showArrow && (
          <div className={cls(styles.value, valueClassName)}>{value}</div>
        )}
      </div>
    )
  );
};
